import { ChangeEvent } from "react";

type Option = {
    [key: string]: any;
};

type InputSelectProps = {
    name: string;
    label: string;
    value: string;
    options: Option[];
    optionsText: string;
    optionsValue: string;
    required?: boolean;
    publicField?: boolean;
    help?: string;
    onChange: (value: string) => void;
    loading?: boolean;
};

export default function InputSelect({
                                        name,
                                        label,
                                        value,
                                        options,
                                        optionsText,
                                        optionsValue,
                                        required = false,
                                        publicField = false,
                                        help,
                                        onChange,
                                    }: InputSelectProps) {
    const handleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        onChange(e.target.value);
    };

    return (
        <div className="zooza_forms__input_select">
        <div className="form_label">
        <label htmlFor={name}>
            <span>{label}</span>
    {required && (
        <abbr className="required" title="required">
    <em className="icon-sun-3"></em>
        </abbr>
    )}
    {publicField && (
        <abbr className="public" title="public">
    <em className="icon-unhide"></em>
        </abbr>
    )}
    </label>
    </div>

    <div className="form_item">
    <select
        id={name}
    name={name}
    required={required}
    value={value}
    onChange={handleChange}
    className="select-css"
        >
        {options.map((option) => (
                <option key={option[optionsValue]} value={option[optionsValue]}>
            {option[optionsText]}
            </option>
))}
    </select>
    {help && <div className="form_item_help">{help}</div>}
        </div>
        </div>
    );
    }



